export const PASSENGERS_SITE_SECTION_ID = 'passengers';
export const NEWS_SITE_SECTION_ID = 'news';
export const BUSINESS_SITE_SECTION_ID = 'business';
export const COMMUNITY_SITE_SECTION_ID = 'community';
export const CAREERS_SITE_SECTION_ID = 'site-section-careers';
